import React, { FC, useState, useEffect } from 'react';
import TitleLabel from 'src/components/atoms/label/TitleLabel';
import RequiredLabel from 'src/components/atoms/label/Required';
import './style.scss';

interface Props {
  status?: string;
  value?: string;
  placeholder?: string;
  styleDef?: React.CSSProperties;
  boxStyleDef?: React.CSSProperties;
  labelStyleDef?: React.CSSProperties;
  inpStyleDef?: React.CSSProperties;
  changeEvt?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  confirmEvent?: () => void;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  label?: string;
  required?: string;
  labelType?: string;
  labelPosition?: string;
  type?: string;
  name?: string;
}

const InputBox: FC<Props> = ({
  status = '',
  placeholder = '',
  value = '',
  inputRef,
  confirmEvent,
  changeEvt,
  boxStyleDef,
  styleDef,
  labelType = '',
  labelStyleDef,
  inpStyleDef,
  label = '',
  required = '',
  type = 'text',
  labelPosition = '',
  name = '',
}) => {
  // Value
  const labelWidth = styleDef?.minWidth || '80px';
  const fontSize = styleDef?.fontSize || '14px';
  // State
  const [viewStatus, setViewStatus] = useState({ status: status || '' });
  useEffect(() => {
    setViewStatus({ status: status });
  }, [status]);

  // Event
  const onKeydownEvt = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      confirmEvent !== undefined && confirmEvent();
    }
  };
  const focusEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewStatus({ status: '_active' });
  };
  const focusOutEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewStatus({ status: '' });
  };
  const changeEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (changeEvt) changeEvt(e);
  };
  return (
    <div
      className={['_input_default_box', viewStatus.status, labelPosition].join(' ')}
      style={boxStyleDef}
    >
      {label !== '' ? (
        <div className="_label">
          <TitleLabel
            label={label}
            labelPosition={labelPosition}
            styleDef={labelStyleDef}
            type={labelType}
            // required={required}
          />
        </div>
      ) : (
        ''
      )}
      <div className="_input" style={styleDef}>
        {required === 'Y' ? <RequiredLabel /> : ''}
        <input
          name={name}
          style={inpStyleDef}
          type={type}
          placeholder={placeholder}
          value={value}
          ref={inputRef}
          onKeyDown={e => onKeydownEvt(e)}
          onChange={e => changeEvent(e)}
          onFocus={e => focusEvent(e)}
          onBlur={e => focusOutEvent(e)}
          disabled={
            viewStatus.status === '_disable' || viewStatus.status === '_read' ? true : false
          }
        />
      </div>
    </div>
  );
};

export default InputBox;
